import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { QResourceRoutes } from '@qualio/ui-components';
import { globalSearchApi, medtechApi, qriApi } from './api';
import { MainContainer } from './components';
import { UserPermissionsProvider } from './context';
import {
  EventDetailsContent,
  EventDetailsRouteGuard,
  EventTemplate,
  QualityEventTemplates,
  TaskDetailsProxy,
} from './views';
import EditContentTemplate from './views/Templates/EditContentTemplate/EditContentTemplate';
import FormEditorOverview from './views/Templates/FormEditorOverview/FormEditorOverview';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { LaunchDarklyDebug } from './views/LaunchDarklyDebug/LaunchDarklyDebug';
import { useFlags } from './external/LaunchDarklyAdapter';
import EventListView from './views/Events/EventListView/EventListView';
import { EventFormView } from './views/Events/EventFormView/EventFormView';
import { setQriServiceUrl } from './utils/qriServiceUrl';

const App: React.FC = () => {
  const showDesignControlsProjectLabel = useFlags('dcLinkResourceLibraryProduct');
  setQriServiceUrl(Boolean(useFlags('mtbeNewStagingDomain')));

  return (
    <MainContainer>
      <UserPermissionsProvider>
        <Router basename={'/quality-events/'} useTransitions={false}>
          <Routes>
            <Route index element={<EventListView />} />
            <Route path="events" element={<EventListView />} />
            <Route path="templates" element={<QualityEventTemplates />} />
            <Route path="templates/:eventTemplateId" element={<EventTemplate />} />
            <Route
              path="templates/:eventTemplateId/content-templates/:contentTemplateId/edit"
              element={<EditContentTemplate />}
            />
            <Route
              path="templates/:eventTemplateId/form-templates/:formTemplateId/edit"
              element={<FormEditorOverview />}
            />
            <Route
              path="events/:eventId/steps/:stepId/forms/:formId"
              element={<EventFormView key="view" viewType="view" />}
            />
            <Route
              path="events/:eventId/steps/:stepId/forms/:formId/edit"
              element={<EventFormView key="edit" viewType="edit" />}
            />
            {QResourceRoutes({
              path: 'events/:eventId',
              mtbeClient: medtechApi,
              qriClient: qriApi,
              globalSearchClient: globalSearchApi,
              element: <EventDetailsRouteGuard />,
              withTasks: true,
              withRelationships: true,
              showDesignControlsProjectLabel,
              children: <Route path="details" element={<EventDetailsContent />} />,
            })}
            <Route path="tasks/:taskId" element={<TaskDetailsProxy />} />
            <Route
              path="debug/ld"
              element={
                <ProtectedRoute
                  outlet={<LaunchDarklyDebug />}
                  requiredFeatureFlags={[]}
                  redirectPath="/"
                  requireStaff
                />
              }
            />
          </Routes>
        </Router>
      </UserPermissionsProvider>
    </MainContainer>
  );
};

export default App;
